import React from "react";
import Marquee from "react-fast-marquee";

export default function Clients({ items = [] }) {
  const list = items.length ? items : [{ name: "Porsche" }, { name: "Red Bull" }, { name: "BMW" }, { name: "Mercedes-Benz" }, { name: "Vivo" }, { name: "Itaú" }, { name: "Bradesco" }];
  return (
    <section className="relative py-20 bg-black border-y border-white/5" data-testid="clients-section">
      <div className="max-w-[1400px] mx-auto px-6 mb-10">
        <div className="flex items-center gap-3">
          <span className="h-[1px] w-10 bg-[#E31B23]" />
          <span className="overline">Confiam na Sim Experience</span>
        </div>
      </div>
      <div className="marquee-mask">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {list.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              className="mx-4 md:mx-10 flex items-center justify-center"
              data-testid={`client-logo-${i}`}
            >
              {c.logo_url ? (
                <img src={c.logo_url} alt={c.name} className="h-10 md:h-14 object-contain grayscale hover:grayscale-0 hover:brightness-125 transition duration-300" />
              ) : (
                <span className="font-display font-black text-2xl md:text-4xl text-white/40 hover:text-white transition-colors tracking-widest">
                  {c.name.toUpperCase()}
                </span>
              )}
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
